export enum TypeCode {
  Document = 1,
  Route = 2,
}
